<template>
  <button
    class="data-plans-slider-item"
    :class="{ primary, filled: bundle?.primary }"
    @click="goBundleDetails"
  >
    <div class="data-plans-item-head-group">
      <div class="data-plans-item-head">
        <div class="gb-info">
          {{ bundle.dataAmountGb() }} GB {{ bundle.duration }} days
        </div>
        <p v-if="bundle?.primary">
          Regional plan: <b>{{ bundle.countries.length }}</b>
          {{ bundle.countries.length > 1 ? "countries" : "country" }}
        </p>
        <BundleCountries
          v-if="!bundle?.primary"
          :countries="bundle?.countries || []"
          :requested-countries="requestedCountries || []"
        />
      </div>
      <div class="price-main-row">
        <BundleCountries
          v-if="bundle?.primary"
          :countries="bundle?.countries || []"
          :requested-countries="requestedCountries || []"
          :show-max-countries-length="3"
        />
        <span class="price-main"> ${{ bundle.priceUsd() }} </span>
      </div>
    </div>
    <div class="b-info-gb">
      <p v-if="primary" class="b-info__recommended">Recommended plan</p>
      <button v-if="bundle" class="view-btn" @click="goBundleDetails">
        View offer
      </button>
    </div>
  </button>
</template>

<script setup lang="ts">
import { defineProps, PropType } from "vue";
import BundleCountries from "@/components/bundle/BundleCountries.vue";
import { Bundle, useBundleStore } from "@/stores/bundle";
import { Country } from "@/stores/data";
import router from "@/router";

const props = defineProps({
  bundle: Bundle,
  requestedCountries: Array as PropType<Array<Country>>,
  primary: {
    type: Boolean,
    default: false,
  },
});

const bundleStore = useBundleStore();

const goBundleDetails = () => {
  bundleStore.addBundle(props.bundle);
  router.push(
    `/bundle/${props.bundle?.id}?requestedCountries=${JSON.stringify(
      props.requestedCountries?.map((c) => c.iso)
    )}`
  );
};
</script>

<style scoped lang="sass"></style>
